


























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
    name: 'feedback-icon',
})
export default class FeedbackIcon extends Vue {
    @Prop({ required: true })
    width!: number;
    @Prop({ required: true })
    height!: number;
    @Prop({ required: true })
    iconColor!: string;
}
